import { axios } from '@Root/API'

export const deleteGoogle2fa = code => {
  return axios.delete('/users-google-key/delete')
}
